import { useState, useEffect } from "react";

export default function AlertaCarrossel({ alertas }) {
  const [idx, setIdx] = useState(0);
  const [visivel, setVisivel] = useState(true);
  useEffect(() => {
    if (alertas.length <= 1) return;
    const t = setInterval(() => {
      setVisivel(false);
      setTimeout(() => { setIdx(i => (i + 1) % alertas.length); setVisivel(true); }, 400);
    }, 3500);
    return () => clearInterval(t);
  }, [alertas.length]);
  if (!alertas.length) return null;
  const a = alertas[idx];
  const corBg = a.tipo === "atrasada" ? "bg-red-50 border-red-100" : a.tipo === "vence_hoje" ? "bg-amber-50 border-amber-100" : "bg-gray-50 border-gray-100";
  const emoji = a.tipo === "atrasada" ? "🔴" : a.tipo === "vence_hoje" ? "🟠" : "🟡";
  return (
    <div className="max-w-6xl mx-auto px-4 pt-3">
      <div className={`flex items-center gap-3 px-4 py-3 rounded-xl border transition-all duration-400 ${corBg}`}
        style={{ opacity: visivel ? 1 : 0, transform: visivel ? "translateY(0)" : "translateY(-4px)" }}>
        <span>{emoji}</span>
        <div className="flex-1 min-w-0">
          <p className="text-xs font-semibold text-gray-800 truncate">{a.titulo}</p>
          <p className="text-xs text-gray-500">{a.mensagem}</p>
        </div>
        {alertas.length > 1 && (
          <div className="flex gap-1 flex-shrink-0">
            {alertas.map((_, i) => <div key={i} className={`w-1.5 h-1.5 rounded-full transition-all ${i === idx ? "bg-gray-600" : "bg-gray-300"}`} />)}
          </div>
        )}
      </div>
    </div>
  );
}
